import { render, staticRenderFns } from "./Realisationdetails.vue?vue&type=template&id=6107ac50&scoped=true"
import script from "./Realisationdetails.vue?vue&type=script&lang=js"
export * from "./Realisationdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107ac50",
  null
  
)

export default component.exports